import type { VisibilityMap } from "../../../../../../components/Questionnaire/validation/form/types";
import type { Groups, Answers, UpdateAnswerPayload } from "../../../../types";
import { deriveNoGroupUpdates } from "./deriveNoGroupUpdates";
import { deriveYesGroupUpdates } from "./deriveYesGroupUpdates";

type ApplyYesNoToggleUpdatesArgs = {
  groupNames: string[];
  groups: Groups;
  answers: Answers;
  visibility: VisibilityMap;
  serverVisibleByName: Record<string, boolean>;
  value: UpdateAnswerPayload["value"];
};

export const applyYesNoToggleUpdates = ({
  groupNames,
  groups,
  answers,
  visibility,
  serverVisibleByName,
  value,
}: ApplyYesNoToggleUpdatesArgs): {
  answers: Answers;
  visibility: VisibilityMap;
} => {
  if (value === "no") {
    return deriveNoGroupUpdates({ groupNames, groups, answers, visibility });
  } else if (value === "yes") {
    return deriveYesGroupUpdates({
      groupNames,
      groups,
      answers,
      visibility,
      serverVisibleByName,
    });
  }

  return { answers, visibility };
};
